/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

export function notification(type, text, delay) {
  if (type === void 0) {
    type = 'success';
  }
  if (delay === void 0) {
    delay = 5500;
  }
  if (type === 'error') {
    type = 'danger';
  }
  Toastify({
    text: text,
    duration: delay,
    close: true,
    gravity: "top",
    // `top` or `bottom`
    position: "right",
    // `left`, `center` or `right`
    className: "bg-" + type
  }).showToast();
}